<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div v-else class="animated fadeIn">
    <basic-heading :title="'Receiving Sample Batch'" class="print-hidden mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <ReceiveScanner />
    <BatchRecieveServerTable
      @itemsListUpdated="(val) => receiving_list = val"
      :receiveList="receiveList"
      :collection="sample_collection"
    />
    <b-button
      @click="openConfirmModal"
      class="my-4 float-right py-3 px-5"
      variant="success"
    >
      Recieved
    </b-button>
    <BatchRecieveModalConfirm @confirm="receive" :receivedList="receiving_list" />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import SampleCollection from "../../../collections/lab/SampleCollection";
import SampleReceiveTable from "../../../components/lab/sample/SampleReceiveTable";
import LoadingOverlay from "../../../components/shared/LoadingOverlay";
import ToastNotifications from "../../../components/shared/mixins/ToastNotifications";
import SampleReceivingLabels from "../../../components/lab/sample/SampleReceivingLabels";
import { mapGetters } from "vuex";
import BatchRecieveServerTable from "../../../components/lab/sample/BatchRecieveServerTable";
import BatchRecieveModalConfirm from "../../../components/lab/sample/modal/BatchRecieveModalConfirm";
import ReceiveScanner from "@/components/lab/sample/ReceiveScanner.vue";
import SampleModel from '@/models/lab/SampleModel';

export default {
  name: "ReceiveBatch",
  components: {
    SampleReceivingLabels,
    LoadingOverlay,
    SampleReceiveTable,
    BasicHeading,
    HeaderButtonGroup,
    BatchRecieveServerTable,
    BatchRecieveModalConfirm,
    ReceiveScanner
},
  mixins: [ToastNotifications],
  computed: {
    ...mapGetters({
      receiveList: "receiveStore",
    }),
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/samples/receive",
            title: "To All receiving",
            variant: "primary",
          },
        ],
      };
    },
  },
  data() {
    return {
      loading: true,
      project: null,
      project_id: this.$route.params.project_id || null,
      sample_collection: new SampleCollection(),
      receiving: false,
      receiving_list: [],
      receiving_list_copy: [],
      ignoreCheck: false,
    };
  },
  methods: {
    print(sample) {
      this.quickInfoToast(
        "Printing Sample",
        `Sample ${sample.get("receiving_id")} will be printed shortly...`
      );
    },
    removeReceivedSamples() {
      const models = this.sample_collection.models;
      this.receiving_list.forEach((sample, index) => {
        const foundModelIndex = models.findIndex(el => el.id === sample.id);
        if (foundModelIndex >= 0) {
          models.splice(foundModelIndex, 1);
        }
      });
      this.sample_collection.replace(models);
    },
    openConfirmModal() {
      if (!this.receiving_list.length) {
        this.quickWarningToast('Nothing selected to receive', 'Please select some samples to receive!');
        return;
      }
      this.$bvModal.show('batch-recieve-modal');
    },
    receive() {
      const payload = this.receiving_list.map(sample => {
        return {
          sample_id: sample.id
        }
      });
      const sample = new SampleModel();
      sample
        .updateStatusBatch("Received", payload)
        .then(() => {
          this.quickSuccessToast("Marked received", "Sample(s) were successfully marked received");

          // create copy of the receiving_list to pass as a prop to the print screen
          // remove the receiving list from the main display collection
          this.removeReceivedSamples();
          this.ignoreCheck = true;

          this.$router.push({
            name: 'Receive Samples Print',
            params: {
              receiveList: this.receiving_list
            }
          });
        })
        .catch((err) => {
          this.quickWarningToast("Could not mark received", "Sample could not be marked received");
        });
    }
  },
  created() {
    this.loading = true;
    let submissionIds = [];
    this.receiveList.forEach((submission) => {
      submissionIds.push(submission.id);
    });
    let sampleCollection = new SampleCollection();
    sampleCollection.getFilter().filterIn('submission_id', submissionIds);
    sampleCollection.getFilter().filterNull('received_at');
    sampleCollection.fetch().then(() => {
      this.sample_collection = sampleCollection;
    });
    this.loading = false;
  },
  beforeRouteLeave(to, from, next) {
    if (!this.receiving_list.length || this.ignoreCheck) {
      next();
      return;
    }
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!');
    if (answer) {
      next();
    } else {
      next(false)
    }
  }
};
</script>
